<div class="audit-error-table">
    <h3>
        Audit Error
    </h3>

    <pageable-table
        [items]="auditErrors"
        [paging]="paging"
        [columns]="getColumnMap()"
        (refreshData)="getAuditErrors($event)">
    </pageable-table>
</div>